// extracted by mini-css-extract-plugin
export default {"navigation":"SAZM87","item":"SVZVI2","active":"_cj4ls"};